import BaseUrl from "../component/BaseUrl";

export const getPayments = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetUserPaymentList?transactionNumber=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}